import { useState } from "react"
import { toast } from "react-toastify"
import { criptografarDado, descriptografarDado } from "../../helpers"
import { modalEmailPreview } from "../../interfaces/processoSeletivo"
import { enviarEmailCandidato } from "../../services/bancoTalentos"
import { Button } from "../Styles"

function ModalEmailPreview({ processoSeletivo, onClose, candidatosSelecionados }: modalEmailPreview) {
    const [processando, setProcessando] = useState(false);

    const enviarEmail = async () => {
        const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
        const permissoesAutorizadas = ['master', 'consultor', 'recrutamento_banco_talentos']
        const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

        if(!temPermissao) return toast.warn("Você não tem permissão para convidar candidatos para seus processos seletivos.")

        if (!processoSeletivo) return toast.error("Processo Seletivo não encontrado.")
        if (!candidatosSelecionados || candidatosSelecionados.length === 0) return toast.error("Nenhum candidato selecionado.")

        setProcessando(true)
        try {
            const idsCandidatosCript = candidatosSelecionados.map(id =>
                criptografarDado(id.toString())
            )
            const idProcessoSeletivoCript = criptografarDado(processoSeletivo.id.toString())

            const resposta = await enviarEmailCandidato(idProcessoSeletivoCript, idsCandidatosCript)

            if (resposta.status === 200) {
                toast.success("E-mails enviados com sucesso.")
                onClose()
                return
            }

        } catch (error: any) {
            if (error.status === 403) {
                toast.error("Um ou mais candidatos não autorizaram o envio de e-mail.")
                onClose()
                return
            }
            toast.error("Erro ao enviar emails para os candidatos.")
            onClose()
            return
        } finally {
            setProcessando(false)
        }
    }

    return (
        <div className="fundoModal">
            <section className='containerModalCentro'>
                <span className='novoContainerTitulo'>
                    <h1>
                        Preview do Email
                    </h1>
                </span>

                <div className="container-email-preview">
                    <h3>
                        Olá, candidato(a)!
                    </h3>

                    <p>
                        Identificamos uma oportunidade que pode ser perfeita para você em nosso sistema:
                    </p>

                    <div className="info-email-preview">
                        <p>
                            <strong>Cargo:</strong> {processoSeletivo.titulo}
                        </p>
                        <p>
                            <strong>Localização:</strong> {processoSeletivo.localTrabalhoCidade} / {processoSeletivo.localTrabalhoEstado}
                        </p>
                        <p>
                            <strong>Tipo de contratação:</strong> {processoSeletivo.regimeContratacao}
                        </p>
                        <p>
                            <strong>Tipo de processo:</strong> {processoSeletivo.tipoProcesso}
                        </p>
                        <p>
                            <strong>Modalidade:</strong> {processoSeletivo.modalidadeTrabalho}
                        </p>
                    </div>

                    <div className="container-btn">
                        <Button type='button' cor='solicitarUsuario' isLoading={false}>
                            Ir para a vaga
                        </Button>
                    </div>

                    <p className="inf-responsabilidade">
                        As informações sobre a vaga são de responsabilidade do contratante.
                        O envio deste e-mail não representa garantia de contratação ou vínculo empregatício.
                    </p>
                </div>

                <span className="botoesContainer">
                    <Button type='button' cor='cancelar' isLoading={processando} onClick={() => onClose()}>
                        Voltar
                    </Button>
                    <Button type='button' cor='enviar' isLoading={processando} onClick={() => enviarEmail()}>
                        Enviar Email
                    </Button>
                </span>
            </section>
        </div>
    );
}

export default ModalEmailPreview;
